module.exports = __webpack_public_path__ + "assets/img/btn-play-purple.bf8b60c9.svg";